<!-- Image -->
@if (initialRender()) {
  <img
    [ngSrc]="listing().primaryImage"
    [alt]="listing().address.streetAddress"
    width="344"
    height="224"
    class="w-full aspect-video object-cover h-56"
    placeholder
    [priority]="true"
  />
} @else {
  <img
    [ngSrc]="listing().primaryImage"
    [alt]="listing().address.streetAddress"
    width="344"
    height="224"
    class="w-full aspect-video object-cover h-56"
    placeholder
  />
}

<!-- Tags -->
<div class="absolute top-0 left-0 flex gap-1 p-2 flex-wrap">
  @if (openNow() || listing().openTomorrow) {
    <app-home-listing-card-open-house
      [listing]="listing()"
      [openNow]="openNow()"
      class="flex gap-1"
    />
  }

  <app-home-listing-card-features [listing]="listing()" class="flex gap-1" />
</div>

<!-- Details -->
<div class="grid grid-cols-[1fr_auto] px-2 py-3 gap-x-2">
  <div class="flex flex-col gap-0.5 text-sm leading-tight min-w-0">
    <div class="flex items-center gap-2">
      <p class="truncate dark:text-gray-100!">{{ listing().model?.displayTitle }}</p>
    </div>

    <p class="truncate">
      <strong>{{ listing().beds }}</strong> bd | <strong>{{ baths() }}</strong> ba |
      @if (listing().den ?? listing().customFilters?.den) {
        <strong>1</strong> den |
      }
      <strong>{{ $safeNavigationMigration(listing().squareFeet?.total) | number }}</strong> sqft
    </p>

    <!-- Address -->
    <p class="truncate" [title]="listing().address.streetAddress">
      {{ listing().address.streetAddress }}
    </p>

    <!-- Village -->
    @if (stateService.community() === 'villages') {
      <p class="truncate" [title]="listing().village.displayTitle ?? ''">
        {{ listing().village.displayTitle ?? listing().village.displayTitle }}
      </p>
    }
  </div>

  <div class="flex flex-col-reverse items-end justify-between shrink-0">
    <app-save-listing [listing]="listing()" />

    @if (!listing().pending) {
      <p
        class="font-header text-lg sm:text-2xl leading-none text-primary-500 dark:text-white/70 whitespace-nowrap"
      >
        {{ listing().price | currency: 'USD' : 'symbol' : '1.0-0' }}
      </p>
    }
  </div>
</div>
